/* Broche storefront helpers. Small, dependency-free. */
(() => {
  const fmt = (cents) => 'Rs.' + Math.round(cents / 100).toLocaleString('en-PK');

  /* Add one or more variants to the cart and open Dawn's cart drawer. */
  async function brocheAdd(items, button) {
    const drawer = document.querySelector('cart-drawer');
    const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : [];
    const label = button ? button.innerHTML : '';
    if (button) { button.setAttribute('disabled', ''); button.setAttribute('aria-busy', 'true'); button.innerHTML = 'Adding…'; }
    try {
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'broche', cartData: data });
      }
      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else {
        window.location.href = window.routes.cart_url;
      }
      button && (button.innerHTML = button.dataset.addedLabel || label);
      if (button && button.dataset.addedLabel) setTimeout(() => (button.innerHTML = label), 2500);
    } catch (e) {
      if (button) {
        button.innerHTML = 'Try again';
        setTimeout(() => (button.innerHTML = label), 2200);
      }
      console.error('[Broche]', e);
    } finally {
      if (button) { button.removeAttribute('disabled'); button.removeAttribute('aria-busy'); }
    }
  }
  window.brocheAdd = brocheAdd;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-broche-add]');
    if (!btn) return;
    e.preventDefault();
    const ids = btn.dataset.brocheAdd.split(',').filter(Boolean);
    brocheAdd(ids.map((id) => ({ id: Number(id), quantity: 1 })), btn);
  });

  /* Free-delivery progress: product-page bars + cart drawer + cart page. */
  const cfg = window.Broche || {};
  let lastCart = null;
  const shipHTML = (cart) => {
    const t = cfg.freeShipping;
    const left = Math.max(0, t - cart.total_price);
    const pct = Math.min(100, (cart.total_price / t) * 100);
    const msg = left > 0
      ? (cart.item_count ? `You're ${fmt(left)} away from free delivery` : `Free delivery on orders over ${fmt(t)}`)
      : "You've unlocked free delivery";
    return `<div class="b-ship" role="status"><p class="b-ship__msg">${msg}</p><div class="b-ship__bar" aria-hidden="true"><span class="b-ship__fill" style="width:${pct}%"></span></div></div>`;
  };
  function upsert(container, cart) {
    const old = container.querySelector(':scope > .b-ship');
    if (old) old.outerHTML = shipHTML(cart);
    else container.insertAdjacentHTML('afterbegin', shipHTML(cart));
  }
  /* Product page: count the product being viewed ("With this item you're Rs X away"). */
  const pdpHTML = (cart, price) => {
    const t = cfg.freeShipping;
    const total = cart.total_price;
    const after = total + price;
    let msg;
    if (total >= t) msg = "You've unlocked free delivery";
    else if (after >= t) msg = 'Add this and your order gets <b>free delivery</b>';
    else msg = `With this item you're <b>${fmt(t - after)}</b> away from free delivery`;
    const pct = Math.min(100, (Math.max(total, after) / t) * 100);
    return `<div class="b-ship b-ship--pdp" role="status"><p class="b-ship__msg">${msg}</p><div class="b-ship__bar" aria-hidden="true"><span class="b-ship__fill" style="width:${pct}%"></span></div></div>`;
  };
  /* Cart drawer: "Add one more" one-tap add-ons, skipping anything already in the cart. */
  const esc = (x) => String(x).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  function upsellPicks(cart) {
    const list = cfg.upsell || [];
    if (!list.length || !cart || !cart.item_count) return [];
    const inP = new Set(cart.items.map((i) => i.product_id));
    const ok = (x) => !inP.has(x.p);
    let picks = list.filter((x) => x.g === 1 && ok(x)).slice(0, 2).concat(list.filter((x) => x.g === 2 && ok(x)).slice(0, 1));
    if (picks.length < 3) picks = picks.concat(list.filter((x) => ok(x) && !picks.includes(x)).slice(0, 3 - picks.length));
    return picks;
  }
  function paintUpsell(cart) {
    const items = document.querySelector('#CartDrawer-CartItems');
    if (!items) return;
    const old = items.querySelector('.b-upsell');
    const picks = upsellPicks(cart);
    if (!picks.length) { if (old) old.remove(); return; }
    const left = Math.max(0, (cfg.freeShipping || 0) - cart.total_price);
    const head = `${esc(cfg.upsellHeading || 'Add one more')}${left > 0 && cfg.freeShipping ? ` <span>· ${fmt(left)} to free delivery</span>` : ''}`;
    const rows = picks.map((x) => `<li class="b-upsell__item">
      <a class="b-upsell__img" href="${esc(x.u)}" tabindex="-1" aria-hidden="true">${x.img ? `<img src="${esc(x.img)}" alt="" width="56" height="56" loading="lazy">` : ''}</a>
      <div class="b-upsell__info"><a class="b-upsell__name" href="${esc(x.u)}">${esc(x.t)}</a><span class="b-upsell__price">${x.vt ? esc(x.vt) + ' · ' : ''}${fmt(x.pr)}</span></div>
      <button type="button" class="b-upsell__btn" data-broche-add="${x.v}" data-added-label="Added" aria-label="Add ${esc(x.t)} to cart">+ Add</button>
    </li>`).join('');
    const html = `<div class="b-upsell"><p class="b-upsell__h">${head}</p><ul class="b-upsell__list" role="list">${rows}</ul></div>`;
    if (old) old.outerHTML = html; else items.insertAdjacentHTML('beforeend', html);
  }
  function paint(cart) {
    if (!cfg.freeShipping || !cart) return;
    lastCart = cart;
    document.querySelectorAll('[data-broche-ship]').forEach((el) => (el.innerHTML = el.dataset.price ? pdpHTML(cart, Number(el.dataset.price)) : shipHTML(cart)));
    paintUpsell(cart);
    const items = document.querySelector('#CartDrawer-CartItems');
    if (items && cart.item_count) upsert(items, cart);
    const page = document.querySelector('.cart__footer .cart__blocks');
    if (page) upsert(page, cart);
    const ctas = document.querySelector('cart-drawer .cart__ctas');
    if (ctas && !document.querySelector('cart-drawer .b-cart-trust')) {
      const bits = [cfg.cod ? 'Cash on delivery' : '', cfg.dispatch || ''].filter(Boolean);
      if (bits.length) ctas.insertAdjacentHTML('afterend', `<p class="b-cart-trust">${bits.map((b) => `<span>${b}</span>`).join('')}</p>`);
    }
  }
  /* During a sale: "You're saving Rs X" at the top of the cart. */
  async function paintSavings() {
    if (!cfg.sale || !cfg.saleSaving) return;
    const items = document.querySelector('#CartDrawer-CartItems');
    if (!items) return;
    try {
      const data = await fetch(`${window.routes.root_url || '/'}?sections=broche-cart-savings`).then((r) => r.json());
      const holder = document.createElement('div');
      holder.innerHTML = data['broche-cart-savings'] || '';
      const el = holder.querySelector('[data-broche-savings]');
      const amount = el ? Number(el.dataset.brocheSavings) : 0;
      const old = items.querySelector('.b-save');
      if (old) old.remove();
      if (amount > 0) items.insertAdjacentHTML('afterbegin', `<p class="b-save" role="status"><span aria-hidden="true">🎉</span> ${cfg.saleSavingText || "Sale prices applied · You're saving"} ${el.dataset.brocheSavingsText}</p>`);
    } catch (e) {}
  }
  /* One cart request at a time; repeated triggers share it. */
  let inflight = null;
  const refresh = () => {
    if (inflight) return inflight;
    inflight = fetch(`${window.routes.cart_url}.js`).then((r) => r.json())
      .then((c) => { paint(c); paintSavings(); })
      .catch(() => {})
      .finally(() => { inflight = null; });
    return inflight;
  };
  const needsCart = () => document.querySelector('[data-broche-ship], cart-drawer:not(.is-empty), .cart__footer');
  document.addEventListener('DOMContentLoaded', () => {
    if (needsCart()) {
      ('requestIdleCallback' in window ? requestIdleCallback : setTimeout)(refresh);
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => refresh());
      /* Product page: when the size changes (15ml / 60ml), recount with the new price. */
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        const v = e && e.data && e.data.variant;
        if (!v) return;
        document.querySelectorAll('[data-broche-ship][data-price]').forEach((el) => { el.dataset.price = v.price; el.dataset.variant = v.id; });
        if (lastCart) paint(lastCart);
      });
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          if (lastCart && (!drawer.querySelector('.b-ship') || !drawer.querySelector('.b-cart-trust') || (upsellPicks(lastCart).length && !drawer.querySelector('.b-upsell')))) paint(lastCart);
        });
      }).observe(drawer, { childList: true, subtree: true });
    }
  });

  /* Product page: put the Judge.me review widget inside a collapsed "Customer reviews" tab. */
  const REV_SEL = '.jdgm-review-widget, .jdgm-rev-widg, #judgeme_product_reviews';
  function reviewMeta(root) {
    const src = root.querySelector('[data-average-rating]') || document.querySelector('.product .jdgm-prev-badge[data-average-rating]');
    if (!src) return '';
    const avg = parseFloat(src.dataset.averageRating || '0');
    const n = parseInt(src.dataset.numberOfReviews || '0', 10);
    if (!n) return '';
    return ` <span class="b-rev-meta"><span aria-hidden="true">★</span> ${avg.toFixed(1)} · ${n} review${n === 1 ? '' : 's'}</span>`;
  }
  function wrapReviews() {
    if (document.getElementById('BrocheReviews')) return true;
    const widget = document.querySelector('.product ' + REV_SEL.split(', ').join(', .product '));
    if (!widget) return false;
    const block = widget.closest('.shopify-app-block') || widget;
    const d = document.createElement('details');
    d.id = 'BrocheReviews';
    d.className = 'product__accordion accordion b-reviews-acc';
    d.innerHTML = `<summary><div class="summary__title"><h2 class="h4 accordion__title">Customer reviews<span class="b-rev-slot"></span></h2></div><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg></summary><div class="accordion__content b-reviews-acc__body"></div>`;
    block.parentNode.insertBefore(d, block);
    d.querySelector('.b-reviews-acc__body').appendChild(block);
    const fill = () => { const m = reviewMeta(d); if (m) d.querySelector('.b-rev-slot').innerHTML = m; return !!m; };
    if (!fill()) { let tries = 0; const t = setInterval(() => { if (fill() || ++tries > 20) clearInterval(t); }, 500); }
    return true;
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.product')) return;
    if (!wrapReviews()) {
      const mo = new MutationObserver(() => { if (wrapReviews()) mo.disconnect(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => mo.disconnect(), 10000);
    }
  });
  /* Tapping the star badge opens the reviews tab and scrolls to it. */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.jdgm-prev-badge, a[href*="judgeme_product_reviews"]')) return;
    const d = document.getElementById('BrocheReviews');
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }, true);

  /* Sticky add-to-cart: show once the main button scrolls away. */
  document.addEventListener('DOMContentLoaded', () => {
    const bar = document.querySelector('[data-broche-sticky]');
    const main = document.querySelector('.product-form__submit');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    const priceSrc = document.querySelector('.product .price__container');
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.querySelectorAll('a,button').forEach((el) => (el.tabIndex = show ? 0 : -1));
      if (show && priceSrc) {
        const p = priceSrc.querySelector('.price-item--sale, .price-item--regular');
        if (p) bar.querySelector('.b-sticky__price').textContent = p.textContent.trim();
      }
    }).observe(main);
    bar.querySelector('button').addEventListener('click', () => {
      main.click();
    });
  });
})();

/* Broche sale mode: countdowns, auto switch-off at the end time, and the welcome popup. */
(() => {
  const cfg = window.Broche || {};
  if (!cfg.sale) return;
  const end = Number(cfg.saleEnd) || 0;
  const pad = (n) => String(n).padStart(2, '0');
  function parts() {
    let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    const d = Math.floor(s / 86400); s %= 86400;
    const h = Math.floor(s / 3600); s %= 3600;
    const m = Math.floor(s / 60); s %= 60;
    return { d, h, m, s };
  }
  function tick() {
    if (!end) return;
    const left = end - Date.now();
    if (left <= 0 && cfg.saleAutoOff) {
      document.querySelectorAll('[data-b-sale-el]').forEach((el) => el.remove());
      document.querySelectorAll('.announcement-bar-section').forEach((el) => el.style.setProperty('display', 'block', 'important'));
      clearInterval(timer);
      return;
    }
    const p = parts();
    const txt = (p.d ? pad(p.d) + 'd ' : '') + pad(p.h) + 'h ' + pad(p.m) + 'm ' + pad(p.s) + 's';
    document.querySelectorAll('[data-b-countdown]').forEach((el) => (el.textContent = txt));
    document.querySelectorAll('[data-b-countdown-boxes]').forEach((box) => {
      ['d', 'h', 'm', 's'].forEach((u) => { const b = box.querySelector(`[data-u="${u}"]`); if (b) b.textContent = pad(p[u]); });
    });
  }
  const timer = end ? setInterval(tick, 1000) : null;
  document.addEventListener('DOMContentLoaded', tick);
  tick();

  document.addEventListener('DOMContentLoaded', () => {
    const pop = document.getElementById('BrochePop');
    if (!pop || document.documentElement.classList.contains('shopify-design-mode')) return;
    let seen = false;
    try { seen = sessionStorage.getItem('bSalePop') === '1'; } catch (e) {}
    if (seen) return;
    let lastFocus = null;
    const close = () => {
      pop.hidden = true;
      document.body.style.overflow = '';
      try { sessionStorage.setItem('bSalePop', '1'); } catch (e) {}
      if (lastFocus) lastFocus.focus();
    };
    const open = () => {
      if (document.querySelector('cart-drawer.active, .quick-add-modal[open]')) { setTimeout(open, 3000); return; }
      lastFocus = document.activeElement;
      pop.hidden = false;
      document.body.style.overflow = 'hidden';
      const btn = pop.querySelector('.b-pop__btn');
      if (btn) btn.focus();
    };
    pop.addEventListener('click', (e) => { if (e.target === pop || e.target.closest('[data-b-pop-close]')) close(); });
    pop.querySelector('.b-pop__btn')?.addEventListener('click', () => { try { sessionStorage.setItem('bSalePop', '1'); } catch (e) {} });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) close(); });
    setTimeout(open, (Number(pop.dataset.delay) || 0) * 1000);
  });
})();

/* Image descriptions: product cards whose photo has no alt text use the product name. */
(() => {
  const fill = (root) => {
    root.querySelectorAll('.card-wrapper img:not([alt]), .card-wrapper img[alt=""]').forEach((img) => {
      const t = img.closest('.card-wrapper')?.querySelector('.card__heading a')?.textContent.trim();
      if (t) img.alt = t;
    });
  };
  document.addEventListener('DOMContentLoaded', () => {
    fill(document);
    let q = false;
    new MutationObserver(() => {
      if (q) return;
      q = true;
      requestAnimationFrame(() => { q = false; fill(document); });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();

/* Accessibility: give quantity boxes a readable name (Dawn labels them in a way screen readers miss). */
(() => { const name = () => document.querySelectorAll('input.quantity__input:not([aria-label])').forEach((i) => i.setAttribute('aria-label', 'Quantity'));
  document.addEventListener('DOMContentLoaded', name); document.addEventListener('shopify:section:load', name); })();
